<div class="compare-modal">
  <div class="comparison-grid-wrapper">
    <!-- HEADER -->
    <div class="d-flex w-100 mb-5">
      <div class="d-flex align-items-start justify-content-between w-100" style="gap: 15px;">
        <div class="d-flex align-items-center">
          <h2 class="mb-1" style="font-family: 'Rubik', serif; font-weight: 400; font-size: 33px; line-height: 1; margin-right: 25px;">
            <span style="line-height: 1.2;">
              Comparación
            </span>
            <br />
            <span style="font-weight: 700"> de planes </span>
          </h2>

          <div>
            <img src="../../../assets/icons/itinerary-detail/FLECHA_VOUCHER-01.svg" style="width: 58px; height: 58px; transform: scaleX(-1);" alt="" />
          </div>
        </div>

        <button type="button" class="close-btn" aria-label="Close" (click)="close()">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
    </div>

    <!-- Selector global para una sola marca con muchos planes -->
    <div
      *ngIf="isSingleBrand && availableBrands.length > 0 && showSelectorsByBrand[availableBrands[0]]"
      class="global-plan-selector mb-3"
      style="text-align: center;"
    >
      <label style="font-family: &quot;Rubik&quot;, serif; font-weight: 500; margin-right: 10px">Cambiar planes:</label>
      <select
        [ngModel]="getSelectedValue(availableBrands[0])"
        (ngModelChange)="onPlanSelectChange(availableBrands[0], $event)"
        class="form-control form-control-sm d-inline-block"
        style="width: auto; font-family: &quot;Rubik&quot;, serif; font-size: 12px; background-color: transparent;"
      >
        <option *ngFor="let option of getPlanOptions(availableBrands[0])" [value]="option.index">
          {{ option.label }}
        </option>
      </select>
    </div>

    <!-- Grilla única: cards en row 1, coberturas en rows siguientes -->
    <div
      class="comparison-grid"
      [class.has-selector]="hasAnyPlanSelector"
      [style.grid-template-columns]="gridTemplateColumns"
    >
      <!-- Celda vacía arriba-izquierda (encima de los nombres de cobertura) -->
      <div class="grid-header-spacer" style="grid-row: 1; grid-column: 1;"></div>

      <!-- CARDS DE PLANES (row 1, columnas 2..N+1) -->
      <ng-container *ngFor="let insurance of flatVisiblePlansLimited; let i = index">
        <div
          class="plan-card-wrapper"
          style="margin: 0px 10px; min-width: 232px;"
          [style.grid-row]="'1'"
          [style.grid-column]="i + 2"
        >
          <div
            class="plan-card d-flex flex-column align-items-center"
          >
            <!-- Header de la card: logo + nombre del plan + selector por marca -->
            <div class="d-flex flex-column align-items-center w-100 plan-card__header" style="background-color: #f7f7f7; padding-bottom: 10px; height: 100%;">
              <img
                [src]="insurance?.provider?.logo"
                alt="{{ insurance.plan.planName }}"
                class="mt-4"
                style="height: 60px; width: 140px; object-fit: contain;"
              />
              <p
                class="mt-1 mx-auto"
                style="
                  font-family: 'Rubik', serif;
                  font-weight: 400;
                  font-size: 11px;
                  text-align: center;
                  margin-bottom: 0;
                  color: #666666;
                "
              >
                PLAN
              </p>

              <div class="w-100 px-5" style="margin: 5px 0px;">
                <hr class="w-100 m-0" style="border-top: 0; border-bottom: 1px solid #5c5c5c" />
              </div>

              <p
                *ngIf="!showSelectorsByBrand[insurance.plan.brand]"
                class="mt-1 mb-3"
                style="
                  font-family: 'Muli', sans-serif;
                  font-weight: 600;
                  font-size: 12px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  line-height: 1.2;
                  text-align: center;
                  padding: 0px 50px;
                "
              >
                {{ insurance.plan.planName }}
              </p>

              <!-- Selector de planes (solo si la marca tiene más de 1 plan) -->
              <div
                *ngIf="showSelectorsByBrand[insurance.plan.brand]"
                class="plan-selector mb-3"
                style="max-width: 125px;"
              >
                <select
                  [ngModel]="getSelectedValue(insurance.plan.brand)"
                  (ngModelChange)="onPlanSelectChange(insurance.plan.brand, $event)"
                  class="form-control mx-auto text-center"
                  style="font-family: &quot;Rubik&quot;, serif; font-size: 12px; width: 80%; background-color: transparent !important;
                  border: none;"
                >
                  <option
                    *ngFor="let option of getPlanOptions(insurance.plan.brand)"
                    [value]="option.index"
                  >
                    {{ getOptionLabel(option, insurance.plan.brand) }}
                  </option>
                </select>
              </div>
            </div>

            <!-- Cuerpo de la card: precio + descuento -->
            <div
              class="d-flex flex-column align-items-center justify-content-center py-3"
              style="width: 100%; background-color: #e9e9e9; position: relative; min-height: 150px;"
            >
              <div
                id="triangle_down"
                style="border-top: 8px solid #f7f7f7 !important; position: absolute; top: 0; transform: translate(0%)"
              ></div>

              <div
                *ngIf="insurance.plan?.pricing?.promotions && insurance.plan?.pricing?.promotions.length > 0"
                style="height: 14px"
              >
                <p
                  class="mb-0"
                  style="font-family: &quot;Rubik&quot;, serif; line-height: 1"
                >
                  <span
                    style="font-weight: 400; font-size: 12px; text-decoration: line-through"
                    >{{ insurance.plan.pricing.currency }} {{ insurance.plan.totalPriceProf | number: "1.2-2" }}</span
                  >
                </p>
              </div>

              <p
                class="mb-0"
                style="font-family: &quot;Rubik&quot;, serif; line-height: 1.5"
              >
                <span style="font-weight: 500; font-size: 14px">{{ currencyAgency?.code }} </span>
                <span
                  style="font-weight: 600; color: #2e2f43;"
                  [ngStyle]="{ 'font-size': getPrincipalCurrencyFontSize(insurance) }"
                >
                  {{
                    (insurance.plan?.pricing?.promotions && insurance.plan?.pricing?.promotions.length > 0
                      ? insurance.plan.pricing?.promotions[0].finalPrice
                      : insurance.plan.totalPriceProf
                    )
                      | currencyConverterPure: insurance.plan.pricing.currency : currencyAgency?.code : currencies
                      | number: "1.2-2"
                  }}
                </span>
              </p>

              <p class="m-0" style="font-family: &quot;Rubik&quot;, serif; line-height: 1">
                <span style="font-weight: 500; font-size: 18px"
                  >{{ insurance.plan.pricing.currency }}
                  {{
                    (insurance.plan?.pricing?.promotions && insurance.plan?.pricing?.promotions.length > 0
                      ? insurance.plan.pricing?.promotions[0].finalPrice
                      : insurance.plan.totalPriceProf
                    ) | number: "1.2-2"
                  }}</span
                >
              </p>

              <div
                *ngIf="insurance.plan?.pricing?.promotions && insurance.plan?.pricing?.promotions.length > 0"
                style="height: 33px"
              >
                <span
                  class="mb-4"
                >
                  <div
                    class="d-flex align-items-center justify-content-center py-1"
                    style="margin-left: -4px; width: 95px; background-color: white; border: 2px solid red; border-radius: 50rem"
                  >
                    <p
                      class="mb-0 mr-2"
                      style="font-family: &quot;Rubik&quot;, serif; font-size: 14px; font-weight: 700; color: red"
                    >
                      {{ insurance.plan?.pricing?.promotions[0].discountValue }}% OFF
                    </p>
                  </div>
                </span>
              </div>
            </div>

            <div id="triangle_down"></div>

            <!-- Botón COMPRAR (parte de la card, va arriba) -->
            <div style="width: 100%; margin-top: 5px;">
              <button
                type="button"
                class="d-flex justify-content-center align-items-center buy-button"
                style="
                  width: 100%;
                  height: 60px;
                  border-bottom-left-radius: 23px;
                  border-bottom-right-radius: 23px;
                  border: none;
                  transition: all 0.3s ease;
                  background-color: #000000;
                "
                [ngStyle]="{
                  'color': clientSetting?.clients_setting_global?.color_main_1
                }"
                (click)="buttonRedirectPlan(insurance)"
                (mouseenter)="setButtonHover(insurance.plan.planId, true)"
                (mouseleave)="setButtonHover(insurance.plan.planId, false)"
              >
                <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-weight: 500; font-size: 16px">COMPRAR</p>
              </button>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- CARDS PLACEHOLDER (rellenan hasta 4 columnas) -->
      <ng-container *ngFor="let slot of placeholderSlots; let i = index; trackBy: trackByIndex">
        <div
          class="plan-card-wrapper"
          style="margin: 0px 10px; min-width: 232px;"
          [style.grid-row]="'1'"
          [style.grid-column]="(flatVisiblePlansLimited.length + i) + 2"
        >
          <div
            class="plan-card plan-card--placeholder d-flex flex-column align-items-center"
          >
            <!-- Header gris con la X -->
            <div class="d-flex flex-column align-items-center w-100 plan-card__header" style="background-color: #f7f7f7; padding-bottom: 10px; min-height: 155px; height: 100%;"></div>

            <!-- Cuerpo gris -->
            <div
              class="d-flex flex-column align-items-center justify-content-center py-3"
              style="width: 100%; background-color: #e9e9e9; position: relative; min-height: 150px;"
            >
              <div
                id="triangle_down"
                style="border-top: 8px solid #f7f7f7 !important; position: absolute; top: 0; transform: translate(0%)"
              ></div>
            </div>

            <div id="triangle_down"></div>

            <!-- Botón gris deshabilitado (parte inferior) -->
            <div style="width: 100%; margin-top: 5px;">
              <div
                style="
                  width: 100%;
                  height: 60px;
                  border-bottom-left-radius: 23px;
                  border-bottom-right-radius: 23px;
                  background-color: #cccccc;
                "
              ></div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- FILAS DE COBERTURAS (a partir de row 2) -->
      <ng-container *ngFor="let row of comparisonData; let rowIndex = index">
        <!-- Columna 1: nombre de la cobertura -->
        <div
          class="coverage-name-cell"
          [style.grid-row]="rowIndex + 2"
          style="grid-column: 1; border-bottom: 1px solid #6c6b6e; padding: 25px 0px; word-wrap: break-word; display: flex; align-items: center;"
        >
          <p class="mb-0" style="font-family: 'Poppins'; font-size: 17px; font-weight: 600; line-height: 1.3;">
            {{ capitalize(row.coverageName) }}
          </p>
        </div>

        <!-- Columnas dinámicas: una celda por plan visible -->
        <ng-container *ngFor="let insurance of flatVisiblePlansLimited; let colIndex = index">
          <div
            class="coverage-value-cell"
            [style.grid-row]="rowIndex + 2"
            [style.grid-column]="colIndex + 2"
            style="border-bottom: 1px solid #6c6b6e; padding: 35px 0px; text-align: center; display: flex; align-items: center;  justify-content: center;"
          >
            <span
                *ngIf="row.plans[insurance.plan.planId]?.coverageAmount !== null && row.plans[insurance.plan.planId]?.coverageAmount !== undefined"
                style="color: #4c4c4c; font-family: 'Poppins'; font-size: 17px; line-height: 1; font-weight: 400;"
              >
              <ng-container
                *ngIf="row.plans[insurance.plan.planId]?.exists; else noCoverage"
              >
              <ng-container *ngIf="isString(row.plans[insurance.plan.planId]?.coverageAmount); else numericCoverage">

                  {{ row.plans[insurance.plan.planId]?.coverageAmount }}
              </ng-container>
              <ng-template #numericCoverage>
                  {{ row.plans[insurance.plan.planId]?.currency }} {{ row.plans[insurance.plan.planId]?.coverageAmount }}
                  </ng-template>


              </ng-container>
            </span>
            <ng-template #noCoverage>
              <svg
                style="width: 30px;"
                id="Capa_1"
                data-name="Capa 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <defs></defs>
                <path style="fill: #000000;" d="M256,0C114.61,0,0,114.61,0,256S114.61,512,256,512,512,397.39,512,256,397.32.15,256,0Z" />
                <path
                  style="fill: #FFFFFF"
                  d="M341.33,311.19a21.33,21.33,0,1,1-28.89,31.39c-.43-.4-.85-.81-1.25-1.25L256,286.17l-55.17,55.16a21.33,21.33,0,0,1-30.16-30.16L225.84,256l-55.17-55.17a21.33,21.33,0,0,1,30.16-30.16L256,225.84l55.19-55.17a21.33,21.33,0,1,1,31.39,28.89c-.4.44-.81.85-1.25,1.25L286.17,256Z"
                />
              </svg>
            </ng-template>
          </div>
        </ng-container>

        <!-- Celdas placeholder para las columnas sin plan (siempre hasta 4) -->
        <ng-container *ngFor="let slot of placeholderSlots; let i = index; trackBy: trackByIndex">
          <div
            class="coverage-value-cell coverage-value-cell--placeholder"
            [style.grid-row]="rowIndex + 2"
            [style.grid-column]="(flatVisiblePlansLimited.length + i) + 2"
            style="border-bottom: 1px solid #6c6b6e; padding: 35px 0px; text-align: center; display: flex; align-items: center;
            justify-content: center;"
          >
            <svg
              style="width: 30px;"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path style="fill: #e9e9e9;" d="M256,0C114.61,0,0,114.61,0,256S114.61,512,256,512,512,397.39,512,256,397.32.15,256,0Z" />
              <path
                style="fill: #FFFFFF"
                d="M341.33,311.19a21.33,21.33,0,1,1-28.89,31.39c-.43-.4-.85-.81-1.25-1.25L256,286.17l-55.17,55.16a21.33,21.33,0,0,1-30.16-30.16L225.84,256l-55.17-55.17a21.33,21.33,0,0,1,30.16-30.16L256,225.84l55.19-55.17a21.33,21.33,0,1,1,31.39,28.89c-.4.44-.81.85-1.25,1.25L286.17,256Z"
              />
            </svg>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
